package com.merkost.handpass.api.dto.user

import com.merkost.handpass.api.enums.AdminRole
import kotlinx.serialization.Serializable

@Serializable
data class AdminRoleResponse(
    val role: AdminRole? = null
)
